import type { HierarchicalCategoryDTO } from '@/services/generated/ECAPIProductsDTOs';
import type { Category } from '../Category';

export function fromEcapiDto(
  categoryDto: HierarchicalCategoryDTO,
  allCategories: HierarchicalCategoryDTO[],
  depth: number = 3
): Category {
  return {
    id: categoryDto.id,
    name: categoryDto.name,
    code: categoryDto.code,
    description: categoryDto.description,
    subCategories:
      categoryDto?.subCategories?.reduce<Category[]>((acc, subCategoryId) => {
        if (depth > 0) {
          const subCategoryDto = allCategories.find(
            (category) => category.id === subCategoryId
          );
          if (subCategoryDto) {
            acc.push(fromEcapiDto(subCategoryDto, allCategories, depth - 1));
          }
        }
        return acc;
      }, []) ?? []
  };
}
